import React from 'react';
import type { Testimonial } from '../types/content';
type TestimonialCardProps = {
  item: Testimonial;
  className?: string;
};
export function TestimonialCard({
  item,
  className = 'p-8'
}: TestimonialCardProps) {
  return <figure className={`flex h-full flex-col rounded-2xl border border-navy/10 bg-surface shadow-premium ${className}`} data-id="element-222" data-mp="2kg6k4sdd1fc6">
      <div className="text-amber" aria-label="Note de 5 sur 5" data-id="element-223" data-mp="2p8zp9hcqqpos">
        ★★★★★
      </div>
      <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-224" data-mp="2u69kjdmt9vkj">«&nbsp;{item.quote}&nbsp;»</blockquote>
      <figcaption className="mt-7 flex items-center gap-3" data-id="element-225" data-mp="2z7z0n7ow4zfh">
        <span aria-hidden="true" className="flex h-11 w-11 items-center justify-center rounded-full bg-sage/15 text-sm font-bold text-sage" data-id="element-226" data-mp="3460jpsmbgyqy">
          {item.initials}
        </span>
        <span data-id="element-227" data-mp="19s99os02scuz">
          <span className="block font-bold text-navy" data-id="element-228" data-mp="19sr55mewyn1u">{item.name}</span>
          <span className="mt-0.5 block text-xs text-slate" data-id="element-229" data-mp="1dtkrwcgmdvt5">{item.role}</span>
        </span>
      </figcaption>
    </figure>;
}